import { Pipe, PipeTransform } from '@angular/core';
import { Filter, FilterItem, PropertyFilter } from '../../store/search/types';

@Pipe({
  name: 'isPropertyActive',
  standalone: false,
})
export class IsPropertyActivePipe implements PipeTransform {
  transform(
    activeFilters: Filter[],
    propertyFilter: PropertyFilter,
    filterItem: FilterItem,
  ): boolean {
    let isActive: boolean = false;
    isActive =
      activeFilters.find(
        (filter) =>
          filter.name === propertyFilter.propertyId + '/' + filterItem.label &&
          filter.tag === 'Property',
      ) != undefined;
    return isActive;
  }
}
